<template>
    <div v-if="question.isShow" class="question-item">
        <!--<div class="question-title"><i v-if="question.isMust">*</i>{{question.title}}</div>-->
        <div class="question-title"><i v-if="question.isMust">*</i>{{question.serialNumber}}.{{question.title}}</div>
        <div  v-if="question.note">说明：{{question.note}}</div>
        <img class="qs-img-preview" :src="question.pictureUrl" alt="">
        <div class="question-option">
            <div class="option-title">
                <el-select size="small" @change="changeHandler" v-model="question.value" placeholder="请选择">
                    <el-option
                            v-for="item in question.options"
                            :key="item.id"
                            :label="item.optionTitle"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'question-dropDown',
    props: {
      question: { required: true },
      displaySetting: { required: true },
      jumpSetting: { required: true },
      questionList: { required: true },
      patientId: { required: false },
    },
    data () {
      return {
        currentIndex: null,
      }
    },
    mounted () {
      this.getAnswer()
      this.getPicture()
    },

    watch: {
      'question.isShow': {
        handler (val) {
          console.log('show');
          //console.log(val)
          if (!val) {
            this.disabledShowOrHide(this.currentIndex, false)
            // this.question.value = ''
            this.currentIndex = null
          }else {
            // this.getAnswer()
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      changeHandler (value) {
        //console.log(value)
        var index = this.question.options.findIndex(item => item.id == value)
        //console.log(this.currentIndex, index + 1)
        if (this.currentIndex) {
          this.disabledShowOrHide(this.currentIndex, false)
          setTimeout(() => {
            this.disabledShowOrHide(index + 1, true)
          }, 100)
          if (this.currentIndex == index + 1) {
            this.disabledShowOrHide(this.currentIndex, false)
          }
        } else {
          this.disabledShowOrHide(index + 1, true)
        }
        this.currentIndex = index + 1
      },
      selectHandler (item, index) {
        //console.log(this.currentIndex, index + 1)
        if (this.currentIndex) {
          this.disabledShowOrHide(this.currentIndex, false)
          this.disabledShowOrHide(index + 1, true)
          if (this.currentIndex == index + 1) {
            this.disabledShowOrHide(this.currentIndex, false)
          }
        } else {
          this.disabledShowOrHide(index + 1, true)
        }
        this.question.value = item
        if (item.selected) {
          this.currentIndex = index + 1
        } else {
          this.currentIndex = null
        }
      },
      //兼容处理
      disabledShowOrHide (index, boolean) {
        var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
          return it.questionId
        }).flat(9) //平铺数组 兼容处理
        if (disabledList) {
          disabledList.forEach(v => {
            if (this.questionList.find(item => item.id == v)) {
              this.questionList.find(item => item.id == v).isShow = boolean
            }
          })
        }
      },
      checkIsFill () {
        if (this.question.isShow) {
          if (this.question.isMust) {
            if (this.question.value) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return true
        }
      },
      saveAnswer () {
        return new Promise((resolve => {
          var selectAnswer = this.question.options.find(item => item.id == this.question.value)
          var params = {
            operatorId: localStorage.getItem('huidrUserId'),
            questionInfo: this.question.id,
            questionnaireNewId: this.question.questionnaireNewId,
            answerInfo: JSON.stringify(selectAnswer),
            id: this.question.patientAnswerInfoId || null,
            patientId: this.patientId || null,
            questionType: this.question.type||null,
          }
            if (this.$route.query.abnormal=='5') {
              params.isRecord  = true
            }else {
              params.isRecord  = false
            }
          if (this.question.patientAnswerInfoId) {
            this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {
                resolve()
              })
          } else {
            this.$store.dispatch('saveQuestionAnswer', params)
              .then(() => {
                resolve()
              })

          }
          //console.log(params)
        }))

        // this.$store.dispatch('saveQuestionAnswer',)
      },
      getPicture() {
        if(this.question.pictureUrl) {
          this.$store.dispatch('getPicture', {url:[this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
        }
      },
      getAnswer () {

        this.displaySetting.map(item => {
          if (item.newOptionId) {
            item.optionId = this.question.options.findIndex(_it => _it.id == item.newOptionId) + 1
            return item
          }
        })
        if (this.question.value) {
          var optionIndex = this.question.options.findIndex(item => item.id == this.question.value.id)
          //console.log('optionIndex', this.question.options[optionIndex])
          this.currentIndex = optionIndex + 1
          this.question.options[optionIndex] = this.question.value
          this.disabledShowOrHide(optionIndex + 1, true)
          if (this.jumpSetting.length) {
            //console.log(this.jumpSetting.find(item => item.optionId == optionIndex + 1))
            if (this.jumpSetting.find(item => item.optionId == optionIndex + 1)) {
              var questionId = this.jumpSetting.find(item => item.optionId == optionIndex + 1).questionId
              this.$store.dispatch('queryQuestionPageListAsync', {
                questionPageResp: {
                  questionInfoId: questionId,
                  questionnaireNewId: this.question.questionnaireNewId
                }
              })
                .then(res => {
                  this.jumpPageNumber = res.retValue[0].pageNumber
                  this.$emit('setJump', this.jumpPageNumber)
                })
            }

          }
          // let id = this.question.value.id
          // setTimeout(() => {
          //   this.question.value = id
          // },300)
          //如果有跳转逻辑
          // this.question.options.find(item => item.id == this.question.value.id).selected = true
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "questionCommon";

    .question-option {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start !important;

        .option-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            span {
                font-size: 16px;
                margin-left: 10px;
            }
        }

        .option-other {
        }
    }


</style>